<template>
  <!-- Image hotspots are always shown -->
  <BrochureHotspotImageItem
    v-if="hotspot.__typename === 'HotspotImageEntity'"
    :hotspot="hotspotImage"
  />
  <BrochureHotspotLinkItem
    v-else-if="
      hotspotMode === HotspotMode.Links ||
      hotspot.__typename === 'HotspotLinkEntity' ||
      hotspotMode === HotspotMode.ProductsWithLink
    "
    :hotspot="hotspotLink"
  />
  <!-- Hotspots with links aren't being shown in modals for now. -->
  <!-- <BrochureHotspotProductItem -->
    <!-- v-else-if="hotspotMode === HotspotMode.ProductsWithLink" -->
    <!-- :hotspot="hotspotProduct" -->
  <!-- /> -->
  <BrochureHotspotProductItem
    v-else-if="hotspotMode === HotspotMode.ProductsWithoutLink"
    :hotspot="hotspotProductWithoutLink"
  />
</template>

<script setup lang="ts">
import {
  type HotspotFragment,
  type HotspotImageEntity,
  type HotspotLinkEntity,
  HotspotMode,
  type HotspotProductEntity,
} from "~/graphql/generated";

const props = defineProps<{
  hotspot: HotspotFragment;
  hotspotMode: HotspotMode;
}>();

const hotspotImage = props.hotspot as unknown as HotspotImageEntity;
const hotspotLink = props.hotspot as unknown as HotspotLinkEntity;
const hotspotProduct = props.hotspot as unknown as HotspotProductEntity;
const hotspotProductWithoutLink = computed(() => {
  const hotspot = { ...props.hotspot };
  delete hotspot.url;
  return hotspot as unknown as HotspotProductEntity;
});
</script>
